<template>
  <div class="flex_c h100 w100 npp-overlay" style="position: fixed; z-index: 4047; top: 0; left: 0; background: #e6e6e6">
    <div style="z-index: 100; position: absolute; right: 1rem; top: 0.25rem">
      <el-button icon="el-icon-close" circle @click="closeBtn"></el-button>
    </div>
    <iframe ref="taskRef" id="accessTask" :src="taskUrl" style="width: 100%; height: 100%; margin: 0; border: 0"></iframe>
  </div>
</template>

<style scoped></style>

<script>
import {mapState} from 'vuex'
import {showLoading, hideLoading, showToast} from '../../utils/loading'
export default {
  props: {
    addPPTItem: {
      type: Function,
    },
    closeBtn: {
      type: Function,
    },
    currentPage: {type: Number, default: 1},
  },
  computed: {
    ...mapState(['session']),
  },
  data() {
    return {
      taskUrl: null,
      topicsOrClouds: null,
      query: null,
      freePromptCount: 0,
      freePromptAmount: 0,
      consultantType: null,
    }
  },
  beforeDestroy() {
    window.removeEventListener('message', this.onMessage)
  },
  async created() {
    await this.getServiceBooking()
    const part =
      (!['interviewTeacher', 'interview'].includes(this.consultantType) && this.session.task?.service?.participants == 'educators') ||
      this.consultantType == 'interviewTeacher'
        ? 'educators'
        : 'students'
    this.taskUrl = `${hostUrl}/v2/com/prompt/${part}?sid=${this.session._id}`
    if (this.session?.video && !this.session.videoSlide) {
      this.taskUrl += `&mode=video`
    }
    // this.taskUrl = `https://192.168.1.7:9003/v2/com/prompt/${part}?sid=${this.session._id}`
    this.getFreePromptCount()
    window.addEventListener('message', this.onMessage)
  },
  methods: {
    async getFreePromptCount() {
      const res = await App.service('session').get(this.session._id)
      if (!isNaN(parseInt(res?.freePromptCount))) {
        this.freePromptCount = parseInt(res.freePromptCount)
      }
    },
    async getFreePromptAmount() {
      const res = await App.service('session').get(this.session._id)
      if (!isNaN(parseInt(res?.freePromptAmount))) {
        this.freePromptAmount = parseInt(res.freePromptAmount)
      }
    },
    async getServiceBooking() {
      if (this.session.booking) {
        await App.service('service-booking')
          .get(this.session.booking)
          .then((res) => {
            this.consultantType = res?.servicePackUser?.snapshot?.consultant?.type
          })
      }
    },
    async onMessage({data}, a) {
      // this.closeBtn()
      if (data?.app == 'web') {
        if (data.action == 'confirm') {
          showLoading()
          const page = {pic: data.pic}
          if (data.topics || data.clouds) {
            this.topicsOrClouds = data.topics ? data.topics : data.clouds.links[0]?.['goods']
            page.pic = this.topicsOrClouds?.pages?.[0]?.pic
            page.size = this.topicsOrClouds?.pages?.[0]?.size
          } else {
            try {
              if (page.pic?.indexOf('http') == -1) {
                const file = await App.service('files').get(page.pic)
                if (file?.size) {
                  page.size = file.size
                }
              }
            } catch (e) {}
          }

          const query = {_id: this.session._id, index: this.currentPage, page}
          if (data.questions) query.questions = data.questions
          if (data.type) {
            if (data.type === 'choice' && data.questions?.length) {
              const firstQuestion = data.questions[0]
              query.questions = [
                {
                  type: data.type,
                  multi: firstQuestion.multi,
                  scoreEnable: false,
                  tips: data.tips ?? '',
                  options: firstQuestion.options,
                },
              ]
            } else {
              data.type = data.type == 'multimedia' ? 'media' : data.type
              query.questions = [
                {
                  type: data.type,
                  multi: false,
                  scoreEnable: false,
                  tips: data.tips ?? '',
                },
              ]
            }
            if (data.type == 'website') {
              query.questions[0].data = `${hostUrl}${data.url}`
            } else if (data.video?.videoPageId) {
              if (!this.session?.videoSlide) await App.service('session').patch(this.session._id, {videoSlide: true})
              query.video = data.video?.video || {}
              query.videoPageId = data.video?.videoPageId
              query.questions = data.video?.video?.[data.video?.videoPageId]?.questions || []
            } else if (data.type == 'video') {
              query.video = data.video?.videoes || []
              if (!Array.isArray(this.session.video)) {
                this.$notify.info({title: 'Notify', message: 'Prompt cannot be added for this video class.', duration: 3000})
                this.closeBtn()
                hideLoading()
                return
              }
              const combinedVideos = [...this.session.video, ...query.video]
              const allIds = new Set(combinedVideos.map((v) => v._id))

              if (combinedVideos.length !== allIds.size) {
                this.$notify.info({
                  title: 'Notify',
                  message: 'The added prompt should not contain duplicate videos within a classroom video session.',
                  duration: 3000,
                })
                this.closeBtn()
                hideLoading()
                return
              }
              query.questions = query.video.flatMap((v) => v.questions || [])
            }
          }

          if (data.package) {
            if (data.package.attachments?.length) {
              query.materialsList = []
              data.package.attachments.forEach((e) => {
                query.materialsList.push({_id: e._id, type: e.mime.split('/')[0], desc: e.filename, key: e.hash, url: '', size: 0})
              })
            }
          }

          if (data.topics || data.clouds) {
            if (data.topics?.video?.videoes && !this.session.videoSlide) {
              if (!Array.isArray(this.session.video)) {
                this.$notify.info({title: 'Notify', message: 'Prompt cannot be added for this video class.', duration: 3000})
                this.closeBtn()
                hideLoading()
                return
              }
              const combinedVideos = [...this.session.video, ...data.topics.video.videoes]
              const allIds = new Set(combinedVideos.map((v) => v._id))

              if (combinedVideos.length !== allIds.size) {
                this.$notify.info({
                  title: 'Notify',
                  message: 'The added prompt should not contain duplicate videos within a classroom video session.',
                  duration: 3000,
                })
                this.closeBtn()
                hideLoading()
                return
              }
            }
            query.questions = this.topicsOrClouds?.questions
            query.materialsList = this.topicsOrClouds?.materials?.[0]?.list ?? []
            if (data.topics?.videoPageId) {
              if (!this.session?.videoSlide) await App.service('session').patch(this.session._id, {videoSlide: true})
              query.video = data.topics?.video
              query.videoPageId = data.topics?.videoPageId
              query.questions = data.topics?.questions
            }
          }

          if (data.topics && window.currentUserId !== data.topics.uid) {
            if (this.freePromptAmount + data.topics.price < 1000 && this.session.booking) {
              //~~https://github.com/zran-nz/bug/issues/5454#issuecomment-2480407312~~
              //https://github.com/zran-nz/bug/issues/5454#issuecomment-2508864841
              // const freePromptCount = this.freePromptCount + 1
              // await App.service('session').patch(this.session._id, {freePromptCount})
              await App.service('session').patch(this.session._id, {$inc: {freePromptAmount: data.topics.price}})
            } else {
              if (data.topics?.video?.videoes && this.session.video && !this.session.videoSlide) {
                query.video = data.topics.video.videoes
              }
              this.taskUrl = `${hostUrl}/v2/order/confirm/prompt/${data.topics._id}?sessionId=${this.session._id}`
              this.query = query
              hideLoading()
              return
            }
          } else if (data.clouds) {
            if (data.clouds.links[0]?.goods?.video?.videoes && !this.session.videoSlide) {
              query.video = data.clouds.links[0].goods.video.videoes
              if (!Array.isArray(this.session.video)) {
                this.$notify.info({title: 'Notify', message: 'Prompt cannot be added for this video class.', duration: 3000})
                this.closeBtn()
                hideLoading()
                return
              }
              const combinedVideos = [...this.session.video, ...query.video]
              const allIds = new Set(combinedVideos.map((v) => v._id))
              if (combinedVideos.length !== allIds.size) {
                this.$notify.info({
                  title: 'Notify',
                  message: 'The added prompt should not contain duplicate videos within a classroom video session.',
                  duration: 3000,
                })
                this.closeBtn()
                hideLoading()
                return
              }
            }
            if (data.clouds?.links[0]?.goods?.videoPageId) {
              if (!this.session?.videoSlide) await App.service('session').patch(this.session._id, {videoSlide: true})
              query.video = data.clouds?.links[0]?.goods?.video
              query.videoPageId = data.clouds?.links[0]?.goods?.videoPageId
              query.questions = data.clouds?.links[0]?.goods?.questions
              // query.questions = query.video.flatMap(v => v.questions || [])
            }
            await App.service('order').get('usePrompt', {query: {uid: data.clouds.buyer, prompt: data.clouds.links[0]?.['id'], sessionId: this.session._id}})
          }

          let rs = null
          if (data.topics) {
            try {
              rs = await App.service('session').patch('insertPrompts', {_id: this.session._id, promptId: data.topics._id, index: this.currentPage})
            } catch (e) {
              console.error('Failed to insert prompt:', e)
              return
            }
          } else {
            try {
              rs = await App.service('session').patch('newPrompt', query)
            } catch (e) {
              console.error('Failed to insert new prompt:', e)
              return
            }
          }
          this.addPPTItem(rs)
          this.closeBtn()
        } else if (data.action == 'prompt') {
          let rs
          try {
            await App.service('order').get('usePrompt', {query: {uid: data.order.buyer, prompt: data.order.links[0]?.['id'], sessionId: this.session._id}})
            rs = await App.service('session').patch('newPrompt', this.query)
          } catch (e) {
            console.error('Failed to insert new prompt:', e)
            return
          }
          this.addPPTItem(rs)
          this.closeBtn()
        } else if (data.action == 'cancel') {
          this.closeBtn()
        }
      }
    },
  },
}
</script>
